import { Link } from "react-router-dom";

function Drsignup() {
  return (
    <div className="signup-container doctor-bg" style={{ background: "url('/assets/doctor-bg.jpg') no-repeat center center/cover" }}>

      <div className="signup-card">

        <h2 className="signup-title">🩺 Doctor Registration</h2>
        <p className="signup-subtitle">Create your doctor account</p>

        <form>

          <div className="mb-3">
            <label className="form-label">Full Name</label>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Enter your name" 
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input 
              type="email" 
              className="form-control" 
              placeholder="Enter your email" 
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Mobile Number</label>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Enter mobile number" 
            />
          </div>


          

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input 
              type="password" 
              className="form-control" 
              placeholder="Create password" 
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input 
              type="password" 
              className="form-control" 
              placeholder="Confirm password" 
            />
          </div>

          <button className="btn btn-success w-100">
            Register as Doctor
          </button>

        </form>

        <p className="login-text mt-3">
          Already have an account? 
          <Link to="/Drlogin" className="ms-1 fw-bold text-primary">
            Doctor Login
          </Link>
        </p>

        <p className="text-center mt-2">
          <Link to="/" className="text-decoration-none">
            ← Back to Home
          </Link>
        </p>

      </div>

    </div>
  );
}

export default Drsignup;